import {createSlice} from '@reduxjs/toolkit';
import AdminApi from "../../../api/AdminApi";
import {showNotification} from "./notification";

type State = {
    data: { [key: number]: { value: string, label: string } },
    isLoading: boolean,
    error: Object | null,
    cellId: number | null
}

const initialState = {
    data: {},
    isLoading: false,
    error: null,
	cellId: null
}

const referrers = createSlice({
    name: 'referrers',
    initialState,
    reducers: {
        fetchReferrersStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchReferrersSuccess: (state: State, action) => {
			const cellId = action.payload.cellId;
            if (action.payload && action.payload.data) {
                const newData = action.payload.data.map((referrer: { id: string, name: string }) => {
                    return {
                        value: referrer.id,
                        label: referrer.name
                    };
                });
            	state.data = {
					...state.data,
					[cellId]: newData
				}
            }
            state.isLoading = false;
            state.error = false;
            state.cellId = cellId;
        },
        fetchReferrersFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload
        },
        resetReferrers: (state: State, action) => {
            if (action.payload.cellId) {
                delete state.data[action.payload.cellId];
            }
        }
    }
});

// Actions
export const {
    fetchReferrersStart,
    fetchReferrersSuccess,
    fetchReferrersFailed,
    resetReferrers
} = referrers.actions;

export default referrers.reducer;

// Thunk
export const fetchReferrers = (brands: string, search: string, cellId: number) => async (dispatch: Function) => {
    try {
        dispatch(fetchReferrersStart());
        const api = new AdminApi();
        const result = await api.getReferrers(brands, search);
        const payload = {
        	data: result,
			cellId
		}
        dispatch(fetchReferrersSuccess(payload));
    } catch (err: any) {
        dispatch(fetchReferrersFailed(err));
		dispatch(showNotification('error', err.message));
	}
}
